var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVbLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8476 9.54414C35.8889 9.92566 36.6744 10.5316 37.2055 11.3605C37.7352 12.1894 38 13.1963 38 14.3783C38 15.5992 37.6978 16.6929 37.0918 17.6624C36.7058 18.3058 36.224 18.8459 35.6465 19.2828C34.9942 19.7855 34.2266 20.1311 33.3409 20.3166C32.4552 20.5037 31.4931 20.5964 30.4563 20.5964H21.2607V0H31.1236C33.6117 0.0374045 35.3757 0.769037 36.4126 2.1934C37.0365 3.06867 37.3492 4.11749 37.3492 5.33688C37.3492 6.59367 37.0335 7.60509 36.4036 8.36964C36.052 8.79904 35.5328 9.19104 34.8476 9.54414ZM32.1829 3.89905C31.553 3.68509 30.748 3.57737 29.771 3.57737H25.3319V8.11828H30.2917C31.1774 8.11828 31.8971 7.94771 32.4507 7.60808C33.0028 7.26845 33.2796 6.66549 33.2796 5.7992C33.2781 4.84015 32.913 4.20726 32.1829 3.89905ZM32.3938 11.8782C31.9106 11.6552 31.2298 11.5385 30.3545 11.5281H25.3319V17.0191H30.2872C31.1714 17.0191 31.8612 16.8979 32.3534 16.6555C33.2481 16.2081 33.6955 15.3508 33.6955 14.085C33.694 13.0153 33.2601 12.2792 32.3938 11.8782Z",
    fill: "#262D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8906 25.4141L19.9291 22.3739V5.72139C19.9291 4.19379 18.6963 2.95496 17.1747 2.95496H2.76195C1.23585 2.95496 0 4.20277 0 5.74234V22.6387C0 24.1783 1.23734 25.4261 2.76195 25.4261H19.9291V25.4171L21.8906 25.4141ZM11.7809 23.4092H8.36664L2.51658 5.9533H6.37672L10.1321 19.205L13.922 5.9533H17.6774L11.7809 23.4092Z",
    fill: "#262D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1544 26.4226L26.8789 21.928L21.2607 21.9385L24.1544 26.4226Z",
    fill: "#262D38"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbLogoSmall);
export default __webpack_public_path__ + "static/media/vb_logo_small.d6b5943ad873b7023e83459fce1d36a0.svg";
export { ForwardRef as ReactComponent };